import React, { Component } from 'react';
import KMotion from './KMotion';

const getDisplayName = WrappedComponent => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

export const connectAnimation = (AnimationComponent, config) => {
  return function wrapWithConnect(WrappedComponent) {
    class Connect extends Component {
      static handleConfig() {
        const body = document.querySelector('body');
        const isRTL = body && body.dir === 'rtl';
        if (isRTL) {
          return {
            styles: config.stylesRTL || config.styles,
            start: config.startRTL || config.start,
            end: config.endRTL || config.end,
            tween: config.tweenRTL || config.tween,
          };
        }
        return config;
      }

      render() {
        const mergedProps = Object.assign({}, this.props, Connect.handleConfig());
        return React.createElement(AnimationComponent, mergedProps, React.createElement(WrappedComponent, this.props));
      }
    }

    Connect.displayName = `KAnimate(${getDisplayName(WrappedComponent)})`;
    Connect.WrappedComponent = WrappedComponent;
    return Connect;
  };
};

export const connectMotion = config => {
  return connectAnimation(KMotion, config);
};
